import React, {useState} from 'react';
import {connect} from 'react-redux';
import Validator from 'validator';
import {startContactUs} from '../actions/common';
import phone from '../assets/images/contact_phone.png';
import mail from '../assets/images/contact_mail.png';
import address from '../assets/images/contact_location.png';

const ContactUs = (props) => {

    const messageStates = {
        idle: "idle",
        loading: "loading",
        success: "success",
        failure: "failure"
    }

    const [messageStatus, setMessageStatus] = useState(messageStates.idle);
    const [fullname, setFullname] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [email, setEmail] = useState("");
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [fullnameError, setFullnameError] = useState(false);
    const [phoneNoError, setPhoneNoError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [titleError, setTitleError] = useState(false);
    const [bodyError, setBodyError] = useState(false);

    const onFullnameChanged = (e) => {
        setFullname(e.target.value)
    }

    const onPhoneNoChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)){
            setPhoneNo(e.target.value)
        }
    }

    const onEmailChanged = (e) => {
        setEmail(e.target.value)
    }

    const onTitleChanged = (e) => {
        setTitle(e.target.value)
    }

    const onBodyChanged = (e) => {
        setBody(e.target.value)
    }

    const onSendClicked = (e) => {
        let hasError = false;
        if (phoneNo === "" || !phoneNo.match(/^09[0-9]{9}$/)) {
            setPhoneNoError(true);
            hasError = true
        } else {
            setPhoneNoError(false);
        }
        if (fullname === "") {
            setFullnameError(true);
            hasError = true
        } else {
            setFullnameError(false);
        }
        if (email === "" || !Validator.isEmail(email)) {
            setEmailError(true);
            hasError = true
        } else {
            setEmailError(false);
        }
        if (body === "") {
            setBodyError(true);
            hasError = true
        } else {
            setBodyError(false);
        }
        if (title === "") {
            setTitleError(true);
            hasError = true
        } else {
            setTitleError(false);
        }
        if (!hasError){
            setMessageStatus(messageStates.loading)
            props.startContactUs(fullname, email, phoneNo, title, body)
            .then(({
                success,
                error
            }) => {
                if (success) {
                    setMessageStatus(messageStates.success)
                } else {
                    setMessageStatus(messageStates.failure)
                }
            })
        }
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 py-4 justify-content-between about">
            <div className="optimized__d-flex-class flex-column mb-4 about__description">

                {
                messageStatus === messageStates.failure ? ( 
                        <span className = "error-dialog mt-4 mx-4 py-1" >خطا در ارسال پیام</span>
                    ) : (undefined)
                }
                {
                    messageStatus === messageStates.success ? ( 
                        <span className = "success-dialog mt-4 mx-4 py-1" >پیام شما با موفقیت ارسال شد</span>
                    ) : (undefined)
                }

                <input className={`${fullnameError ? "about__input--error" : "about__input"} p-3 mx-4 mt-4`} type="text" value={fullname} onChange={onFullnameChanged} placeholder="نام و نام خانوادگی" />
                <input className={`${phoneNoError ? "about__input--error" : "about__input"} p-3 mx-4 mt-4`} type="text" value={phoneNo} onChange={onPhoneNoChanged} placeholder="تلفن همراه" />
                <input className={`${emailError ? "about__input--error" : "about__input"} p-3 mx-4 mt-4`} type="email"value={email} onChange={onEmailChanged} placeholder="ایمیل" />
                <input className={`${titleError ? "about__input--error" : "about__input"} p-3 mx-4 mt-4`} type="text" value={title} onChange={onTitleChanged} placeholder="عنوان پیام" />
                <textarea className={`${bodyError ? "about__text-area--error" : "about__text-area"} p-3 mx-4 mb-3 mt-4`} type="text" value={body} onChange={onBodyChanged} rows="5" placeholder="متن پیام" />
                <div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={phone}></img>
                        <a className="about__contact-text px-2" href="tel:09391111792">۰۹۳۹۱۱۱۱۷۹۲</a>
                    </div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={address}></img>
                        <span className="about__contact-text text-right px-2">اقدسیه، نرسیده به میدان ارتش، نبش لنگری ساختمان رویال پلاک ۴ واحد ۱</span>
                    </div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={mail}></img>
                        <a className="about__contact-text px-2" href="mailto:info@carclick.ir">info@carclick.ir</a>
                    </div>
                </div>
                
            </div>
            <button className="about__btn py-4" onClick={onSendClicked}>ارسال پیام</button>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
    startContactUs: (fullname, email, phoneNo, title, body) => dispatch(startContactUs({fullname, email, phoneNo, title, body}))
})

export default connect(undefined, mapDispatchToProps)(ContactUs);